﻿Date.prototype.addHours = function (h)
{
    this.setTime(this.getTime() + (h * 60 * 60 * 1000));
    return this;
};

Date.prototype.isDaylightSavingTimeInUK = function()
{
    // Start of daylight saving time in UK is at 1am on the last sunday of March
    var startOfDST = new Date(this.getFullYear(), 2, 31);
    startOfDST.setDate(startOfDST.getDate() - startOfDST.getDay());
    startOfDST.setHours(1);

    // End of daylight saving time in UK is at 2am on the last sunday of October
    var endOfDST = new Date(this.getFullYear(), 9, 31);
    endOfDST.setDate(endOfDST.getDate() - endOfDST.getDay());
    endOfDST.setHours(2);

    return this >= startOfDST && this < endOfDST;
};

Date.prototype.toDateInputValue = (function () {
    var local = new Date(this);
    local.setMinutes(this.getMinutes() - this.getTimezoneOffset());
    return local.toJSON().slice(0, 10);
});

Date.prototype.getDateSuffix = function ()
{
    var d = this.getUTCDate();
    var s = $string('General').ShortFourth;
    if (d === 1 || d == 21 || d == 31) s = $string('General').ShortFirst;
    if (d === 2 || d == 22) s = $string('General').ShortSecond;
    if (d === 3 || d == 23) s = $string('General').ShortThird;

    return s;
};

Date.prototype.isValidaDate = function ()
{
    return this instanceof Date && !isNaN(this);
};

Date.prototype.isToday = function ()
{
    // This method takes into consideration the client's settings' timezone
    var currentDate = Data.getLocalTime(timeControl.getServerTime());
    var thisDate = Data.getLocalTime(this);

    return currentDate.getFullYear() === thisDate.getFullYear()
        && currentDate.getDate() === thisDate.getDate()
        && currentDate.getMonth() === thisDate.getMonth();
};

Date.prototype.isTomorrow = function ()
{
    var tomorrowDate = Data.getLocalTime(timeControl.getServerTime());
    tomorrowDate.setDate(tomorrowDate.getDate() + 1);
    var thisDate = Data.getLocalTime(this);

    return tomorrowDate.getFullYear() === thisDate.getFullYear()
        && tomorrowDate.getDate() === thisDate.getDate()
        && tomorrowDate.getMonth() === thisDate.getMonth();
};